import styled from 'styled-components';

export const ReviewPreviewSection = styled.section`
    width: 100%;
    padding-top: 60px;
    background: #F1FEFF; 

    @media screen and (max-width: 1024px){
        padding-top: 180px;
    }

`;

export const ReviewPreviewHeading = styled.div`
    width: 100%;
    background: #34A853;
    padding: 20px;
    border-radius: 15px;
   max-width: 996px;
    margin: 0 auto 30px auto;

`;

export const ReviewPreviewTitle = styled.h2`
    max-width: 644px;
    margin:0 auto;
    color: #fff;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 44px;
    margin-bottom: 2px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }

    @media screen and (max-width: 991px){
        font-size:18px;
        line-height: 24px;
    }
`;

export const ReviewPreviewStrong = styled.strong`
    color: #333333;
    font-weight: 700;
    cursor:pointer;
`;

export const YourReviewSection = styled.section`
    width: 100%;
    padding-bottom: 30px;
    background: #F1FEFF; 
`;

export const YourReviewGroup = styled.div`
    width: 100%;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0px 10px 10px #0000000D;
    border-radius: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 24px;
 
    @media screen and (max-width: 767px){
        flex-direction: column;
        gap: 20px;
    }
`;

export const YourReviewWrap = styled.div`
    .profile-views,
    .profile-review{
        display: none;
    }
    .profile-user-name{
        display: block
    }
`;

export const YourReviewTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 44px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const YourImpactWrap = styled.div`
    width: 100%;
    max-width: 854px;
    margin-top: 70px;

    @media screen and (max-width: 767px){
        max-width: 100%;
          margin-top: 30px;
    }

    .review-main-title{
        display: none;
    }

    .btn-outline-success-blue{
        display: none;
    }

    .review-help{
        display: none;
    }
`;

export const YourImpactGroup = styled.div`
    width: 100%;
    margin-top: 30px;
`;

export const YourImpactTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 22px;
`;

export const YourImpactButtonWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
    margin-top: 16px;

    @media screen and (max-width: 1200px){
        flex-wrap: wrap;
        row-gap: 20px;
    }
`;

export const YourImpactButton = styled.a`
    max-width: 254px;
    width: 100%;
    background: #3C5B9B;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 10px;
    color: #fff;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    padding: 12px 10px;
    text-decoration: none;
    cursor: pointer;

    @media screen and (max-width: 1200px){
        max-width: inherit;
        width: calc(50% - 10px);
    }

    @media screen and (max-width: 991px){
        width: 100%;
    }

    @media screen and (max-width: 767px){
        width: calc(50% - 10px);
    }

    @media screen and (max-width: 575px){
        width: 100%;
    }

    &.twitter-btn{
        background: #000000;
    }

    &.review-btn{
        background: #33A7AE;
    }
`;

export const ButtonIcon = styled.div`
    width: 24px;
    height: 24px;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const ButtonLabel = styled.div`
    
`;

export const ReviewBottomSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){ 
        padding-bottom: 40px;
    }
`;

export const ReviewButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 15px;

    @media screen and (max-width: 767px){
        flex-wrap: wrap;
        gap: 15px;
        

    }

    .btn-outline-success-blue{
        padding: 12px 19px;
         @media screen and (max-width: 767px){
           width: 100%;
        }
    }

    .learn-qualify-btn{
        transition: all 0.2s ease-in-out;
          @media screen and (max-width: 767px){
           width: 100%;
        }
        &:hover{
            background: #F9DC70;
            color: #333;
        }
    }

    .write-yellow-btn{
        padding: 11px 30px;
          @media screen and (max-width: 767px){
           width: 100%;
        }
    }
`;

export const ReviewRole = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 10px #0000000D;
    border-radius: 15px;
    padding:20px;
    `;

export const Reviewstart = styled.div`
      display: flex;
    justify-content: space-between;
    align-items: center; 
    margin-bottom:20px;
`;

export const ReviewTimecol = styled.span`
     text-align: left;
    font-size:16px;
    line-height:21px;
    letter-spacing: 0px;
    color: #33A7AE;
`;


export const Reviewcontent = styled.p`
    font-size:14px;
    line-height:21px;
    letter-spacing: 0px;
    color: #000;
    word-break: break-all;
`;


export const ReviewImageVideo = styled.div`
    display: flex;
    align-items: center;
    margin-bottom:20px;
    gap:26px;
       @media screen and (max-width:767px){
           flex-wrap: wrap;
       }
`;

export const ImageVideoCol = styled.div`
   width:120px;
   height:120px;
    @media screen and (max-width:767px){
      width:100%;
      height: auto;
    }
   img{
       width: 100%;
           height: 100%;
    border-radius: 10px
    }
      iframe.video {
       border-radius: 10px;
        overflow:hidden;
      @media screen and (max-width:767px){
        width:100%;
         height: auto;
    }
}

.iframe-container{
    width: 100%;
    height: 125px;
    overflow: hidden;
    border: 1px solid #ccc;
    border-radius: 10px

}
   .iframe-container iframe {
    width: 100%;
    height: 100%;
    border: none;
 }
`;

export const DonaterName = styled.div`
     display: flex;
     align-items: center;
         gap: 5px;
`;
export const Rolecol = styled.span`
  font-size: 16px;
    line-height: 21px;
    letter-spacing: 0px;
    color: #33A7AE;
    font-weight: bold;
`;
export const Donorcol = styled.span`
   font-size: 16px;
    line-height: 21px;
    letter-spacing: 0px;
    color: #333333;
    font-weight: bold;
`;

